import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { BaseBusinessMemoBaseBusinessIdPutRequest } from '@/coreInfrastructureModule/axios/generated/baseBusinessManage';
import { IBaseBusinessRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessRepository';
import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { IParentBusinessWithMoveWarehouse } from '../domains/entities/Business';
import { ArrivalInfo } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * 置き場移動を行う
 * 一括で入荷情報を変更する
 */
export class MoveWarehouseUseCase {
  /**
   * 入荷情報を一括で変更する
   * @param repository - 在庫情報のリポジトリ
   * @param changedBusinesses - 変更のあった取引情報
   * @param otherBusinesses - 置き場名以外の情報が一致する取引情報
   */
  static async execute(
    repository: IInventoryRepository,
    changedBusinesses: IParentBusinessWithMoveWarehouse,
    otherBusinesses: IParentBusinessWithMoveWarehouse[]
  ): Promise<INetworkResult<string[], Error>> {
    // 他の取引情報の入荷情報を整える
    const otherArrivalInfo: ArrivalInfo[] = otherBusinesses.map((business): ArrivalInfo => {
      const arrivalAmountAtTargetYearMonth = business.arrivals?.find((arrival) =>
        DateService.compareYearMonths(business.differenceOccurrenceMonthYear, arrival)
      )?.amount;
      const arrivalAmount = arrivalAmountAtTargetYearMonth
        ? arrivalAmountAtTargetYearMonth + business.differenceAmount
        : business.differenceAmount;
      return {
        aggregateBusinessId: business.businessId,
        targetYear: business.differenceOccurrenceMonthYear.year,
        targetMonth: business.differenceOccurrenceMonthYear.month,
        // 入荷数量は修正後の数量を設定する
        arrivalAmount,
      };
    });

    // 変更のあった取引情報の入荷情報を整える
    // otherBusinessesのdifferenceAmountの総数を計算して使用する
    const sumArrivalAmountFromOtherBusiness = otherBusinesses.reduce((acc, business) => acc + business.differenceAmount, 0);
    const arrivalAmountAtTargetYearMonth = changedBusinesses.arrivals?.find((arrival) =>
      DateService.compareYearMonths(changedBusinesses.differenceOccurrenceMonthYear, arrival)
    )?.amount;
    const arrivalAmount = arrivalAmountAtTargetYearMonth
      ? arrivalAmountAtTargetYearMonth + sumArrivalAmountFromOtherBusiness
      : sumArrivalAmountFromOtherBusiness;
    const changedArrivalInfo: ArrivalInfo = {
      aggregateBusinessId: changedBusinesses.businessId,
      targetYear: changedBusinesses.differenceOccurrenceMonthYear.year,
      targetMonth: changedBusinesses.differenceOccurrenceMonthYear.month,
      arrivalAmount,
    };

    try {
      const result = await repository.bulkModifyArrival([changedArrivalInfo, ...otherArrivalInfo]);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: result.status.data,
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
